import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, signal, ViewEncapsulation } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Item } from "../../pojo/Item";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25LoadingInlineModule } from "../s25-loading/s25.loading.inline.module";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { Action, S25ListDataComponent } from "../s25-table-list/s25.list.data.component";
import { ListDataParams2 } from "../../services/list.service";
import { DropDownItem } from "../../pojo/DropDownItem";

@TypeManagerDecorator("s25-ng-quick-search")
@Component({
    selector: "s25-ng-quick-search",
    template: `
        <div class="ngListQuickSearch">
            <div class="ngInlineBlock ngQuickSearchFilters">
                <div class="ngQuickSearchLeft">
                    <input
                        type="text"
                        id="quickSearchInput"
                        class="c-input"
                        placeholder="Keyword Search"
                        [(ngModel)]="searchTerm"
                        (keyup.enter)="runSearch()"
                    />
                </div>
                <div class="ngInlineBlock ngListDomainFilter">
                    <s25-ng-search-dropdown
                        [type]="type"
                        [allowNonQueryId]="false"
                        [(chosen)]="selectedSearch"
                        (chosenChange)="runSearch()"
                    ></s25-ng-search-dropdown>
                </div>
            </div>
            <div class="ngInlineBlock c-margin-bottom--half">
                <button class="ngLeftMargin aw-button aw-button--outline" (click)="runSearch()">Search</button>
                <button class="ngLeftMargin aw-button aw-button--outline" (click)="clearSearch()">Clear Search</button>
            </div>

            @if (showResults()) {
                <s25-ng-list-data [hasSelect]="true" [query]="listParams()" [actions]="actions"></s25-ng-list-data>
            } @else if (searchRunning()) {
                <s25-ng-loading-inline-static></s25-ng-loading-inline-static>
            }
        </div>
    `,
    styles: `
        .ngListDomainFilter {
            min-width: 20em;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [S25DropdownPaginatedModule, S25ListDataComponent, FormsModule, S25LoadingInlineModule],
})
export class S25QuickSearchComponent {
    @Input() type: Item.Subject;
    @Input() compType: "event-quick-search"; //expand this type as more quick search needs come up
    @Input() actions: Action[];

    listParams = signal<ListDataParams2>(undefined);

    searchTerm: string = "";
    selectedSearch: DropDownItem;
    showResults = signal(false);
    searchRunning = signal(false);

    async runSearch() {
        //Run the search using list data service
        this.searchRunning.set(true);
        this.showResults.set(false);
        this.cd.detectChanges();

        const listParams: ListDataParams2 = {
            itemType: this.type,
            page: 0,
            query: this.formQuery(),
            comptype: this.compType,
        };

        this.listParams.set(listParams);
        this.searchRunning.set(false);
        this.showResults.set(true);

        this.cd.detectChanges();
    }

    formQuery() {
        let queryString: string = "";
        if (this.searchTerm) {
            queryString = `name=${encodeURIComponent(this.searchTerm.trim())}`;
        }
        if (this.selectedSearch?.val) {
            queryString += this.selectedSearch.val;
        }
        return queryString;
    }

    constructor(private cd: ChangeDetectorRef) {}

    clearSearch() {
        this.searchTerm = "";
        this.showResults.set(false);
        this.selectedSearch = undefined;
    }
}
